import { render, staticRenderFns } from "./RegistrationComplete.vue?vue&type=template&id=46eb32b1&scoped=true&"
import script from "./RegistrationComplete.vue?vue&type=script&lang=js&"
export * from "./RegistrationComplete.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationComplete.vue?vue&type=style&index=0&id=46eb32b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46eb32b1",
  null
  
)

export default component.exports